"use client";

import { c as _c } from "react/compiler-runtime";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { motion } from "framer-motion";
import { useCallback } from "react";
import { PreviewLeaderboardGalleryCase } from "./components/PreviewLeaderboardGalleryCase";
import { PreviewLeaderboardListCase } from "./components/PreviewLeaderboardListCase";
interface MemesSubmissionPreviewScreenProps {
  readonly previewDrop: ExtendedDrop;
  readonly onBackToEdit: () => void;
  readonly onSubmit: () => void;
  readonly isSubmitting: boolean;
}
export function MemesSubmissionPreviewScreen(t0) {
  const $ = _c(18);
  const {
    previewDrop,
    onBackToEdit,
    onSubmit,
    isSubmitting
  } = t0;
  const onDropClick = _temp;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      opacity: 0,
      y: -20
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-space-y-1"><h4 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100">Submission Preview</h4><p className="tw-mb-0 tw-text-sm tw-text-iron-400">Read-only preview of how your submission may appear in different views.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== previewDrop) {
    t5 = <div className="tw-flex-1 tw-space-y-10 tw-overflow-y-auto tw-px-4 tw-py-2 tw-pt-8 tw-scrollbar-thin tw-scrollbar-track-iron-900 tw-scrollbar-thumb-iron-700">{t4}<PreviewLeaderboardListCase drop={previewDrop} onDropClick={onDropClick} /><PreviewLeaderboardGalleryCase drop={previewDrop} onDropClick={onDropClick} /></div>;
    $[4] = previewDrop;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isSubmitting || $[7] !== onBackToEdit) {
    t6 = <SecondaryButton onClicked={onBackToEdit} disabled={isSubmitting}>Back to Edit</SecondaryButton>;
    $[6] = isSubmitting;
    $[7] = onBackToEdit;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isSubmitting || $[10] !== onSubmit) {
    t7 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={isSubmitting} padding="tw-px-6 tw-py-3">Submit Artwork</PrimaryButton>;
    $[9] = isSubmitting;
    $[10] = onSubmit;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="tw-mt-auto tw-flex tw-items-center tw-justify-between tw-border-t tw-border-iron-800 tw-px-4 tw-pt-6">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t8) {
    t9 = <motion.div initial={t1} animate={t2} exit={t3} className="tw-mx-auto tw-flex tw-h-full tw-max-w-6xl tw-flex-col tw-pb-8">{t5}{t8}</motion.div>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(_drop) {}